import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SectionHeading } from '../components/ui/SectionHeading';
import { motion } from 'framer-motion';
import { Backpack, CheckCircle, AlertCircle } from 'lucide-react';
const packingCategories = [{
  category: 'Clothing - Upper Body',
  items: [{
    name: 'Base layer thermal tops',
    quantity: '2-3',
    essential: true
  }, {
    name: 'Mid-layer fleece jacket',
    quantity: '1-2',
    essential: true
  }, {
    name: 'Down jacket (rated -15°C)',
    quantity: '1',
    essential: true
  }, {
    name: 'Waterproof shell jacket',
    quantity: '1',
    essential: true
  }, {
    name: 'Trekking shirts',
    quantity: '2-3',
    essential: false
  }, {
    name: 'Lightweight gloves',
    quantity: '1 pair',
    essential: true
  }, {
    name: 'Heavy insulated gloves',
    quantity: '1 pair',
    essential: true
  }]
}, {
  category: 'Clothing - Lower Body',
  items: [{
    name: 'Base layer thermal bottoms',
    quantity: '2',
    essential: true
  }, {
    name: 'Trekking pants',
    quantity: '2',
    essential: true
  }, {
    name: 'Waterproof pants',
    quantity: '1',
    essential: true
  }, {
    name: 'Shorts (for lower altitudes)',
    quantity: '1',
    essential: false
  }, {
    name: 'Underwear',
    quantity: '5-7',
    essential: true
  }]
}, {
  category: 'Footwear',
  items: [{
    name: 'Trekking boots (broken in)',
    quantity: '1 pair',
    essential: true
  }, {
    name: 'Camp shoes/sandals',
    quantity: '1 pair',
    essential: false
  }, {
    name: 'Trekking socks (wool/synthetic)',
    quantity: '5-7 pairs',
    essential: true
  }, {
    name: 'Gaiters',
    quantity: '1 pair',
    essential: false
  }]
}, {
  category: 'Head & Face',
  items: [{
    name: 'Warm beanie/hat',
    quantity: '1',
    essential: true
  }, {
    name: 'Sun hat with brim',
    quantity: '1',
    essential: true
  }, {
    name: 'Buff/neck gaiter',
    quantity: '1-2',
    essential: true
  }, {
    name: 'Sunglasses (UV400)',
    quantity: '1',
    essential: true
  }, {
    name: 'Headlamp with extra batteries',
    quantity: '1',
    essential: true
  }]
}, {
  category: 'Sleeping',
  items: [{
    name: 'Sleeping bag (-15°C rated)',
    quantity: '1',
    essential: true
  }, {
    name: 'Sleeping bag liner',
    quantity: '1',
    essential: false
  }, {
    name: 'Inflatable pillow',
    quantity: '1',
    essential: false
  }]
}, {
  category: 'Backpack & Bags',
  items: [{
    name: 'Daypack (30-40L)',
    quantity: '1',
    essential: true
  }, {
    name: 'Duffel bag for porter',
    quantity: '1',
    essential: true
  }, {
    name: 'Dry bags/stuff sacks',
    quantity: '3-5',
    essential: true
  }, {
    name: 'Waterproof pack cover',
    quantity: '1',
    essential: true
  }]
}, {
  category: 'Trekking Gear',
  items: [{
    name: 'Trekking poles',
    quantity: '2',
    essential: true
  }, {
    name: 'Water bottles (1L each)',
    quantity: '2',
    essential: true
  }, {
    name: 'Water purification tablets',
    quantity: '1 pack',
    essential: true
  }, {
    name: 'Thermos flask',
    quantity: '1',
    essential: false
  }]
}, {
  category: 'Personal Care & Medical',
  items: [{
    name: 'Sunscreen (SPF 50+)',
    quantity: '1',
    essential: true
  }, {
    name: 'Lip balm with SPF',
    quantity: '2',
    essential: true
  }, {
    name: 'First aid kit',
    quantity: '1',
    essential: true
  }, {
    name: 'Altitude sickness medication',
    quantity: 'As prescribed',
    essential: true
  }, {
    name: 'Personal medications',
    quantity: 'As needed',
    essential: true
  }, {
    name: 'Toiletries',
    quantity: 'Travel size',
    essential: true
  }, {
    name: 'Hand sanitizer',
    quantity: '1',
    essential: true
  }, {
    name: 'Wet wipes',
    quantity: '1 pack',
    essential: true
  }]
}, {
  category: 'Electronics & Documents',
  items: [{
    name: 'Camera with extra batteries',
    quantity: '1',
    essential: false
  }, {
    name: 'Power bank',
    quantity: '1-2',
    essential: true
  }, {
    name: 'Phone with offline maps',
    quantity: '1',
    essential: true
  }, {
    name: 'Passport & permits',
    quantity: '1 set',
    essential: true
  }, {
    name: 'Travel insurance documents',
    quantity: '1 set',
    essential: true
  }, {
    name: 'Emergency contact info',
    quantity: '1 copy',
    essential: true
  }]
}, {
  category: 'Optional Items',
  items: [{
    name: 'Book or e-reader',
    quantity: '1',
    essential: false
  }, {
    name: 'Playing cards',
    quantity: '1 deck',
    essential: false
  }, {
    name: 'Notebook and pen',
    quantity: '1',
    essential: false
  }, {
    name: 'Earplugs',
    quantity: '1 pair',
    essential: false
  }, {
    name: 'Duct tape',
    quantity: 'Small roll',
    essential: false
  }]
}];
export function PackingListPage() {
  return <div className="min-h-screen bg-white font-sans" data-id="element-1693">
      <Navbar data-id="element-1694" />

      {/* Hero Section */}
      <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center" data-id="element-1695">
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1622296089863-eb7fc530daa8?q=80&w=2070&auto=format&fit=crop")'
      }} data-id="element-1696">
          <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-900/50 to-blue-900/80" data-id="element-1697" />
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto" data-id="element-1698">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex justify-center mb-6" data-id="element-1699">
            <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-1700">
              <Backpack className="text-white" size={32} data-id="element-1701" />
            </div>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-6xl font-bold mb-6 tracking-tight" data-id="element-1702">
            Complete Packing List for EBC
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl text-blue-100 font-light max-w-2xl mx-auto" data-id="element-1703">
            Everything you need to pack for your Everest Base Camp trek
          </motion.p>
        </div>
      </div>

      {/* Overview */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-1704">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1705">
          <SectionHeading title="Packing Smart for High Altitude" subtitle="Overview" data-id="element-1706" />
          <div className="prose prose-lg max-w-none text-stone-700 leading-relaxed space-y-4" data-id="element-1707">
            <p data-id="element-1708">
              Packing for the Everest Base Camp trek requires careful
              consideration. You'll be trekking through diverse climates—from
              subtropical forests to high-altitude glacial terrain—and
              temperatures can range from warm afternoons at lower elevations to
              freezing nights at base camp.
            </p>
            <p data-id="element-1709">
              The key is layering: bring items that can be combined for warmth
              and removed as needed. Quality matters more than quantity—invest
              in good gear that will keep you comfortable and safe. Remember,
              porters will carry your main duffel bag (limited to 15kg), but
              you'll carry your daypack with essentials.
            </p>
          </div>
        </motion.div>
      </section>

      {/* Important Notes */}
      <section className="bg-amber-50 py-16 px-4" data-id="element-1710">
        <div className="max-w-4xl mx-auto" data-id="element-1711">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1712">
            <div className="bg-white rounded-xl p-6 border-l-4 border-green-500" data-id="element-1713">
              <div className="flex items-start gap-3" data-id="element-1714">
                <CheckCircle className="text-green-500 shrink-0 mt-1" size={24} data-id="element-1715" />
                <div data-id="element-1716">
                  <h3 className="font-bold text-stone-900 mb-2" data-id="element-1717">
                    Essential Items
                  </h3>
                  <p className="text-stone-600 text-sm" data-id="element-1718">
                    Items marked as essential are critical for your safety and
                    comfort. Don't skip these.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 border-l-4 border-blue-500" data-id="element-1719">
              <div className="flex items-start gap-3" data-id="element-1720">
                <AlertCircle className="text-blue-500 shrink-0 mt-1" size={24} data-id="element-1721" />
                <div data-id="element-1722">
                  <h3 className="font-bold text-stone-900 mb-2" data-id="element-1723">
                    Weight Limit
                  </h3>
                  <p className="text-stone-600 text-sm" data-id="element-1724">
                    Porter duffel bag: 15kg maximum. Daypack: 5-7kg. Pack wisely
                    and weigh before departure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Packing List Categories */}
      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-1725">
        <SectionHeading title="Detailed Packing List" subtitle="Organized by category" data-id="element-1726" />
        <div className="space-y-8" data-id="element-1727">
          {packingCategories.map((category, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-2xl shadow-md overflow-hidden" data-id="element-1728">
              <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-6 py-4" data-id="element-1729">
                <h3 className="text-xl font-bold text-white" data-id="element-1730">
                  {category.category}
                </h3>
              </div>
              <div className="p-6" data-id="element-1731">
                <div className="space-y-3" data-id="element-1732">
                  {category.items.map((item, itemIndex) => <div key={itemIndex} className="flex items-center justify-between py-3 border-b border-stone-100 last:border-0" data-id="element-1733">
                      <div className="flex items-center gap-3" data-id="element-1734">
                        {item.essential ? <CheckCircle className="text-green-500 shrink-0" size={20} data-id="element-1735" /> : <div className="w-5 h-5 border-2 border-stone-300 rounded shrink-0" data-id="element-1736" />}
                        <span className="text-stone-900 font-medium" data-id="element-1737">
                          {item.name}
                        </span>
                      </div>
                      <span className="text-stone-600 text-sm" data-id="element-1738">
                        {item.quantity}
                      </span>
                    </div>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* Tips Section */}
      <section className="bg-stone-50 py-20 px-4" data-id="element-1739">
        <div className="max-w-4xl mx-auto" data-id="element-1740">
          <SectionHeading title="Packing Tips" subtitle="Expert advice" data-id="element-1741" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1742">
            <div className="bg-white rounded-xl p-6" data-id="element-1743">
              <h3 className="font-bold text-stone-900 mb-3" data-id="element-1744">Test Your Gear</h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-1745">
                Break in your boots on several day hikes before the trek. Test
                your sleeping bag, clothing layers, and backpack to ensure
                everything fits and works properly.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6" data-id="element-1746">
              <h3 className="font-bold text-stone-900 mb-3" data-id="element-1747">
                Use Compression Bags
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-1748">
                Compression bags or stuff sacks help maximize space and keep
                items organized. Use different colors for easy identification.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6" data-id="element-1749">
              <h3 className="font-bold text-stone-900 mb-3" data-id="element-1750">
                Layer Your Clothing
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-1751">
                Pack clothing that can be layered. This system allows you to
                adjust to changing temperatures throughout the day and at
                different altitudes.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6" data-id="element-1752">
              <h3 className="font-bold text-stone-900 mb-3" data-id="element-1753">
                Rent in Kathmandu
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-1754">
                Quality trekking gear can be rented in Kathmandu at reasonable
                prices. This is ideal for items like sleeping bags and down
                jackets if you don't own them.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white" data-id="element-1755">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1756">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-1757">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1758">
              Need Help with Gear Selection?
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-1759">
              Our team can provide personalized packing advice based on the
              season and your trek
            </p>
            <a href="#contact" data-id="element-1760">
              <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold hover:bg-blue-50 transition-colors" data-id="element-1761">
                Contact Our Experts
              </button>
            </a>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-1762" />
    </div>;
}